import script from "./SmartToggleSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartToggleSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./SmartToggleSwitch.vue?vue&type=style&index=0&id=054b386a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054b386a"]])

export default __exports__